export default __webpack_public_path__ + "static/media/OCGO-slider7.6bf14dd4.jpg";